export default __webpack_public_path__ + "media/zurb/img/legacy/clue/instructions-4-5fb7d0a6636e418848e9aa4602b4bbbc.jpg";